import { GETVerifyIdentity } from './requests'
import { useQuery } from '@tanstack/react-query'

function useVerifyIdentity(sessionId: string, programId: number) {
    return useQuery({
        queryKey: ['verifyIdentity', sessionId, programId],
        queryFn: () => GETVerifyIdentity(sessionId, programId),
      });
}

export default useVerifyIdentity
